import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Spin } from 'antd';

import NewCmaForm from '../../forms/NewCmaForm';
import EditCmaForm from '../../forms/EditCmaForm';

import QUERY from '../../graphql/queries/getCustomerCmaQuery.graphql';

const CMA = (props) => {
  const { loading, customerCma } = props.data;
  if (loading) {
    return (
      <Spin size="large" />
    );
  }
  if (customerCma) {
    return (
      <EditCmaForm
        pl_values={JSON.parse(customerCma.values[0].pl_values)}
        bs_values={JSON.parse(customerCma.values[0].bs_values)}
        cf_values={JSON.parse(customerCma.values[0].cf_values)}
        bsa_values={JSON.parse(customerCma.values[0].bsa_values)}
        mpbf_values={JSON.parse(customerCma.values[0].mpbf_values)}
        ffs_values={JSON.parse(customerCma.values[0].ffs_values)}
        kfp_values={JSON.parse(customerCma.values[0].kfp_values)}
        fys={JSON.parse(customerCma.months_each_year)}
      />
    );
  }
  return (
    <div>
      <h4>Create new CMA</h4>
      <NewCmaForm customer_id={props.match.params.id} />
    </div>
  );
};

CMA.propTypes = {
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerCma: PropTypes.object,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default graphql(QUERY, {
  options: ({ match }) => ({ variables: { customer_id: match.params.id } }),
})(CMA);



// WEBPACK FOOTER //
// ./src/pages/customer/CMA.jsx